import React, { useState, useEffect,useRef } from "react";
import { useMachine } from "../../context/MachineContext";
import {Container, Row, Col, Card, CardBody, CardTitle, Button, CardHeader, CardFooter,} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";

const MACHINES = [
  { name: "MCCAUTOCONNECT_LINE1", status: "running" },
  // { name: "MCCAUTOCONNECT_LINE2", status: "running" },
  // { name: "MCCAUTOCONNECT_LINE3", status: "idle" },
  // { name: "INS-4309_36_L1",        status: "running" },
  // { name: "INS-4080_36_L2",        status: "running" },
  // { name: "FR-37-02_37_LF1",       status: "stopped" },
  // { name: "INS-2253_36_LABEL_ROOM", status: "idle" },
  // { name: "INS-3944_40_WH40_1",    status: "running" },
  // { name: "INS-2208_40_WH40_2",    status: "stopped" },
  // { name: "INS-1236_40_WH40_3",    status: "running" },
];


const AIChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [mentionPopup, setMentionPopup] = useState(false);
const [mentionQuery, setMentionQuery]  = useState("");
const [activeIdx, setActiveIdx]        = useState(0);
const filteredMachines = MACHINES.filter(m =>
  m.name.toLowerCase().includes(mentionQuery.toLowerCase())
);
  const [isRecording, setIsRecording] = useState(false);
const mediaRecorderRef = useRef(null);
const audioChunksRef = useRef([]);
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      text: "Hi! I'm your OptiMize AI assistant 👋 Ask me anything about your machines, status, or performance.",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
 
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);
 
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
 
  
 const handleSend = async () => {
  const trimmed = query.trim();
  if (!trimmed || isLoading) return;

  setMessages((prev) => [...prev, { role: "user", text: trimmed }]);
  setQuery("");
  setIsLoading(true);

  try {
    const res = await axios.post("https://api.hanoch.in/ai/ask/", {
      question: trimmed,
    });

    const reply =
      res?.answer ||
      res.data?.response ||
      res.data?.message ||
      "Sorry, I couldn't get a response.";

    setMessages((prev) => [...prev, { role: "assistant", text: reply }]);
  } catch (err) {
    setMessages((prev) => [
      ...prev,
      { role: "assistant", text: "Something went wrong. Please try again." },
    ]);
  } finally {
    setIsLoading(false);
  }
};
 
 const handleQueryChange = (e) => {
  const val = e.target.value;
  setQuery(val);

  // detect @word at cursor
  const caret  = e.target.selectionStart;
  const before = val.slice(0, caret);
  const match  = before.match(/@(\w*)$/);
  if (match) {
    setMentionQuery(match[1]);
    setMentionPopup(true);
    setActiveIdx(0);
  } else {
    setMentionPopup(false);
  }
};

const selectMachine = (name) => {
  // replace the @word before cursor with @MachineName
  const caret  = inputRef.current.selectionStart;
  const before = query.slice(0, caret).replace(/@\w*$/, `@${name} `);
  const after  = query.slice(caret);
  setQuery(before + after);
  setMentionPopup(false);
  setTimeout(() => {
    inputRef.current.focus();
    inputRef.current.setSelectionRange(before.length, before.length);
  }, 0);
};

const handleKeyDown = (e) => {
  if (mentionPopup) {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIdx(i => Math.min(i + 1, filteredMachines.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIdx(i => Math.max(i - 1, 0));
    } else if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();
      if (filteredMachines[activeIdx]) selectMachine(filteredMachines[activeIdx].name);
    } else if (e.key === "Escape") {
      setMentionPopup(false);
    }
    return;
  }
  if (e.key === "Enter" && !e.shiftKey) {
    e.preventDefault();
    handleSend();
  }
};
 
  return (
    <>
      {/* ── Popup ── */}
      {isOpen && (
        <div style={chatStyles.popup}>
          {/* Header */}
          <div style={chatStyles.header}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={chatStyles.headerAvatar}>
                <BotIcon size={155} color="#fff" />
              </div>
              <div>
                <div style={chatStyles.headerTitle}>OptiMize AI</div>
                {/* <div style={chatStyles.headerSub}>
                  <span style={chatStyles.onlineDot} /> Always on
                </div> */}
              </div>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              style={chatStyles.closeBtn}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
 
          {/* Messages */}
          <div style={chatStyles.messages}>
            {messages.map((msg, i) => (
              <div
                key={i}
                style={{
                  ...chatStyles.msgRow,
                  justifyContent:
                    msg.role === "user" ? "flex-end" : "flex-start",
                }}
              >
                {msg.role === "assistant" && (
                  <div style={chatStyles.botAvatar}>
                    <BotIcon size={12} color="#2563eb" />
                  </div>
                )}
                <div
                  style={
                    msg.role === "user"
                      ? chatStyles.userBubble
                      : chatStyles.botBubble
                  }
                >
                  {msg.text}
                </div>
              </div>
            ))}
 
            {isLoading && (
              <div style={{ ...chatStyles.msgRow, justifyContent: "flex-start" }}>
                <div style={chatStyles.botAvatar}>
                  <BotIcon size={26} color="#ffffff" />
                </div>
                <div style={chatStyles.botBubble}>
                  <TypingDots />
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
 
          {/* Input */}
          <div style={chatStyles.inputArea}>
            

  {/* @mention popup */}
  {mentionPopup && filteredMachines.length > 0 && (
    <div style={chatStyles.mentionPopup}>
      {/* <div style={chatStyles.mentionHeader}>Select machine</div> */}
      {filteredMachines.map((m, i) => (
        <div
          key={m.name}
          onMouseDown={(e) => { e.preventDefault(); selectMachine(m.name); }}
          style={{
            ...chatStyles.mentionItem,
            background: i === activeIdx
              ? "var(--color-background-secondary, #f1f5f9)"
              : "transparent",
          }}
        >
          {/* <div style={chatStyles.machineIcon}>⚙️</div> */}
          <div>
            <div style={{ fontSize: 10, fontWeight: 600 }}>{m.name}</div>
            
          </div>
        </div>
      ))}
    </div>
  )}

  <input
    ref={inputRef}
    type="text"
    value={query}
    onChange={handleQueryChange}  
    onKeyDown={handleKeyDown}
    placeholder="Ask anything… type @ to mention a machine"
    style={chatStyles.input}
    disabled={isLoading}
  />
  {/* mic + send buttons unchanged */}

            <button
              onClick={handleSend}
              disabled={isLoading || !query.trim()}
              style={{
                ...chatStyles.sendBtn,
                opacity: isLoading || !query.trim() ? 0.5 : 1,
              }}
              aria-label="Send"
            >
              <SendIcon />
            </button>
          </div>
        </div>
      )}
 
      {/* ── FAB Button ── */}
      <button
        onClick={() => setIsOpen((v) => !v)}
        style={chatStyles.fab}
        aria-label="Open AI assistant"
        title="Ask AI"
      >
        {isOpen ? (
          <span style={{ fontSize: 20, lineHeight: 1 }}>✕</span>
        ) : (
          <BotIcon size={110} color="#fff" />
        )}
        {!isOpen && <span style={chatStyles.fabPulse} />}
      </button>
    </>
  );
};
 
// ─── Tiny SVG icons ───────────────────────────────────────────────────────────
const BotIcon = ({ size }) => (
  <img
    src="/asset/aibluering.gif"
    alt="AI Assistant"
    width={size}
    height={size}
    style={{ objectFit: "contain" }}
  />
);
 
const SendIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);
 
const TypingDots = () => (
  <span style={{ display: "flex", gap: 4, alignItems: "center", padding: "2px 0" }}>
    {[0, 1, 2].map((i) => (
      <span
        key={i}
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: "#94a3b8",
          display: "inline-block",
          animation: "typingBounce 1.2s infinite",
          animationDelay: `${i * 0.2}s`,
        }}
      />
    ))}
    <style>{`
      @keyframes typingBounce {
        0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
        40% { transform: translateY(-5px); opacity: 1; }
      }
      @keyframes fabPulseAnim {
        0% { transform: scale(1); opacity: 0.6; }
        70% { transform: scale(1.8); opacity: 0; }
        100% { transform: scale(1.8); opacity: 0; }
      }
    `}</style>
  </span>
);
 
// ─── Chatbot Styles ───────────────────────────────────────────────────────────
const chatStyles = {
  fab: {
    position: "fixed",
    bottom: 28,
    right: 28,
    width: 58,
    height: 58,
    borderRadius: "50%",
     background:"#0c2455",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // boxShadow: "0 4px 20px rgba(255, 255, 255, 0.45)",
    zIndex: 1050,
    color: "#69aed9",
    fontSize: 22,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    outline: "none",
  },
  fabPulse: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    // background: "rgba(37,99,235,0.4)",
    animation: "fabPulseAnim 2s infinite",
    pointerEvents: "none",
  },
  popup: {
    position: "fixed",
    bottom: 98,
    right: 28,
    width: 360,
    height: 500,
    background: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
    display: "flex",
    flexDirection: "column",
    zIndex: 1049,
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    animation: "slideUp 0.25s ease",
  },
  header: {
    background: "linear-gradient(135deg, #0c2455 0%, #0c2455 100%)",
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
  },
  headerAvatar: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  headerTitle: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: "0.02em",
    fontFamily: "'Rajdhani', sans-serif",
  },
  headerSub: {
    color: "rgba(255,255,255,0.75)",
    fontSize: 11,
    display: "flex",
    alignItems: "center",
    gap: 5,
    marginTop: 1,
  },
  onlineDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#0c2455",
    display: "inline-block",
    boxShadow: "0 0 6px #0c2455",
  },
  closeBtn: {
    background: "rgba(255,255,255,0.15)",
    border: "none",
    color: "#fff",
    width: 28,
    height: 28,
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    flexShrink: 0,
  },
  messages: {
    flex: 1,
    overflowY: "auto",
    padding: "14px 14px 8px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    background: "#f8fafc",
  },
  msgRow: {
    display: "flex",
    alignItems: "flex-end",
    gap: 7,
  },
  botAvatar: {
    width: 16,
    height: 16,
    borderRadius: "50%",
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  botBubble: {
    background: "#0c2455",
    border: "1px solid #e2e8f0",
    borderRadius: "16px 16px 16px 4px",
    padding: "9px 13px",
    fontSize: 12,
    color: "#ffffff",
    maxWidth: "82%",
    lineHeight: 1.5,
    // boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    fontFamily: "sans-serif",
    whiteSpace: "pre-wrap",
  },
  userBubble: {
    background: "linear-gradient(135deg, #0c2455, #0c2455)",
    borderRadius: "16px 16px 4px 16px",
    padding: "9px 13px",
    fontSize: 13,
    color: "#fff",
    maxWidth: "82%",
    lineHeight: 1.5,
    fontFamily: "sans-serif",
    whiteSpace: "pre-wrap",
  },
  inputArea: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 12px",
    borderTop: "1px solid #e2e8f0",
    background: "#fff",
    flexShrink: 0,
  },

  inputArea: {
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "10px 12px",
  borderTop: "1px solid #e2e8f0",
  background: "#fff",
  flexShrink: 0,
  position: "relative",  // ✅ required for mention popup positioning
},

mentionItem: {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "9px 12px",
  cursor: "pointer",        // ✅ pointer cursor
  userSelect: "none",       // ✅ prevents text selection on click
  transition: "background 0.1s",
},
  input: {
    flex: 1,
    border: "1px solid #e2e8f0",
    borderRadius: 24,
    padding: "9px 14px",
    fontSize: 13,
    outline: "none",
    background: "#f8fafc",
    color: "#1e293b",
    fontFamily: "sans-serif",
    transition: "border-color 0.15s",
  },
  sendBtn: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #0c2455, #0c2455)",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    transition: "opacity 0.15s",
  },
};




const MachineSelection = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [machines, setMachines] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
 const { setSelectedMachineId } = useMachine();
  const authToken = localStorage.getItem("access");
  const company = localStorage.getItem("companyid");
  const companyId = localStorage.getItem("companyid");

  const fetchMachines = async () => {
    try {
      setIsLoading(true)
      const response = await axios.get(`https://api.hanoch.in/api/machines/by-company/?id=${company}`);
    setMachines(response);
    console.log("id",response)
      } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      }
       else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };
    useEffect(() => {
    fetchMachines();
  }, []);

  //  const handleMachineClick = (id) => {
  //   setSelectedMachineId(id);
  //   localStorage.setItem('selectedMachineId',id);
  //   navigate("/dashboard", { state: {id} })
  // };

  const handleMachineClick = (id, name) => {
  
   setSelectedMachineId(id);
   localStorage.setItem('selectedMachineId',id);
  if (!companyId) {
    console.error("Company ID not found in localStorage");
    return;
  }

  if (companyId == 6) {
    navigate("/temperatureTrend", { state: {id, name} });
  } else {
    navigate("/dashboard", { state: {id} })
  };
  }
  const machineOrder = [
  "INS-4309_36_L1",
  "INS-4080_36_L2",
  "FR-37-02_37_LF1",
  "INS-2253_36_LABEL ROOM",
  "INS-3944_40_WH40_1",
  "INS-2208_40_WH40_2",
  "INS-1236_40_WH40_3",
];
  document.title = "Overview | OptiMize ";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Overview" />
          <Row>
            <Col xl={4} sm={6}>
              <Card >
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-time-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Machines</p>
                      <h5 className="mb-3">{machines?.total_machines}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={4} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-success" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-checkbox-circle-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Active</p>
                      <h5 className="mb-3">
                        {machines?.active_count}  
                        </h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={4} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      {/* Replace RadialChart with icon */}
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-danger" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-close-circle-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Inactive</p>
                      {/* <h5 className="mb-3">{machines?.data?.length-machines?.running?.length} </h5> */}
                      <h5 className="mb-3">
                        {machines?.inactive_count}
                        </h5>
                      {/* Commented section remains the same */}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* <Col xl={3} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-group-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Work Order</p>
                      <h5 className="mb-3">{machines?.running?.length}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col> */}
          </Row>

          {isLoading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (

            <Row>
             <div
  style={{
    display: "grid",
    gridTemplateColumns: companyId == 6
      ? "repeat(auto-fill, minmax(200px, 1fr))"  // ✅ 5 cols on large, wraps on small
      : "repeat(auto-fill, minmax(250px, 1fr))",  // ✅ 4 cols on large, wraps on small
    gap: "16px",
  }}
>
        

{machines?.data
  ?.sort((a, b) => {
    const indexA = machineOrder.indexOf(a.name);
    const indexB = machineOrder.indexOf(b.name);
    const orderA = indexA === -1 ? 999 : indexA;
    const orderB = indexB === -1 ? 999 : indexB;
    return orderA - orderB;
  })
  .map((machine, index) => (
                
                  <Card
                    onClick={() => handleMachineClick(machine.id, machine.name) }
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    style={{
                      cursor: "pointer",
                      transform: hoveredIndex === index ? "translateY(-3px)" : "none",
                      boxShadow:
                        hoveredIndex === index
                          ? "0 4px 12px rgba(0, 0, 0, 0.15)"
                          : "none",
                      border:
                        hoveredIndex === index ? "1px solidrgb(20, 33, 60)" : "1px solid transparent",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease, border 0.2s ease",
                    }}>
                    <CardHeader>
                      <div className="d-flex justify-content-between align-items-center ">
<span>
 <h6><b> {machine?.name}</b></h6>

</span>
                        <div className="blinking-text">
                          <img
                            width="14"
                            height="14"
                            src={
                              machine?.machine_status === "running"
                                ? "https://img.icons8.com/ios-filled/50/40C057/filled-circle.png"
                                // :"https://img.icons8.com/ios-filled/50/40C057/filled-circle.png"
                                : "https://img.icons8.com/ios-filled/50/FA5252/filled-circle.png"
                            }

                          />
                        </div>
                      </div>

                    </CardHeader>
                    <CardBody>
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="justify-content-center align-items-center">
                          <img src={`https://api.hanoch.in/media/${machine.image}`} alt="machine" height="50" className="align-items-center img-fluid" />

                        </div>
                      </div>
                    </CardBody>
                   <CardFooter>
  <div className="d-flex justify-content-between align-items-center">
    <div>
      {companyId == 6 && (
       <div> <p className="mb-0">
          Temperature : <b>{machine?.temperature}°C</b>
        </p>
         {/* <p className="mb-0">
          Last updated: <b>{machine?.last_seen}</b>
        </p> */}
        </div>
      )}
    </div>
  </div>
</CardFooter>
                  </Card>
                 
              ))}
 </div>
            </Row>
          )}
        </Container>
      </div>
         <AIChatbot />
    </React.Fragment>
  );
};

export default MachineSelection;
